/* global BigInt */
import { Connection, VersionedTransaction } from '@solana/web3.js';
import { lamports, publicKey } from '@metaplex-foundation/umi';
import { transferSol } from '@metaplex-foundation/mpl-toolbox';
import { DEFAULT_SERVICE_FEE, quoteServiceFee } from './serviceFees';

export async function addStudioServiceFee({ builder, umi, wallet, policy, connection }) {
    const rule = policy.studioMintFee || DEFAULT_SERVICE_FEE;
    let baseAmountAtomic = '0';
    if (rule.enabled && rule.mode === 'percentage') {
        builder = await builder.setLatestBlockhash(umi);
        const transaction = VersionedTransaction.deserialize(umi.transactions.serialize(builder.build(umi)));
        const rpc = connection || new Connection(umi.rpc.getEndpoint(), 'confirmed');
        const [networkFee, rent] = await Promise.all([
            rpc.getFeeForMessage(transaction.message, 'confirmed'), builder.getRentCreatedOnChain(umi),
        ]);
        if (!Number.isSafeInteger(networkFee.value) || networkFee.value < 0) throw new Error('The Solana mint cost could not be estimated. Retry before signing.');
        baseAmountAtomic = (BigInt(networkFee.value) + rent.basisPoints).toString();
    }
    const quote = await quoteServiceFee(wallet, 'studioMint', baseAmountAtomic, true, policy.version || 0);
    if (BigInt(quote.solFeeLamports) > 0n) builder = builder.add(transferSol(umi, {
        source: umi.payer, destination: publicKey(quote.treasuryWallet), amount: lamports(BigInt(quote.solFeeLamports)),
    }));
    return { builder, quote };
}
